import React, {useState, useEffect, FormEventHandler} from "react";
import { useBlocker, useLocation, useNavigate } from "react-router-dom";
import NavigateConfirmModal from "../Nav/NavigateConfirmModal.tsx";
import Button from "./Button.tsx";

interface FormProps {
    children?:any,
    unSavedChanges: any,
    handleSubmit: FormEventHandler<HTMLFormElement>,
    isLoading: boolean,
    responseMessage: string,
    responseMessageClass: string,
    className?: string,
    id?: string,
    generalErrors?: string,
    intro?: string,
    displayRequiredHint?: boolean,
    disabled?: boolean,
    customSubmit?: boolean,
    hasInvalidForm?: boolean,
}

const Form = (props:FormProps) => {
    const [navigateConfirmModal, setNavigateConfirmModal] = useState(false);
    const [navigateConfirmModal2, setNavigateConfirmModal2] = useState(false);

    useEffect(() => {
        const handleBeforeUnload = (e) => {
            if (props.unSavedChanges || props.hasInvalidForm) {
                e.preventDefault();
                e.returnValue = "";
                return true;
            }
            return null;
        };
        window.addEventListener("beforeunload", handleBeforeUnload);
        return () => window.removeEventListener("beforeunload", handleBeforeUnload);
    }, [props.unSavedChanges, props.hasInvalidForm]);

    const shouldBlockNavigation = (conf) => {
        if (props.unSavedChanges && conf.currentLocation.pathname !== conf.nextLocation.pathname) {
            setNavigateConfirmModal(true);
            return "Sind Sie sicher, dass Sie die Seite verlassen wollen? Alle nicht gespeicherte Änderungen werden verloren gehen.";
        }
        if (props.hasInvalidForm && conf.currentLocation.pathname !== conf.nextLocation.pathname) {
            setNavigateConfirmModal2(true);
            return "Sind Sie sicher, dass Sie die Seite verlassen wollen? Sie haben noch nicht alle Daten korrekt ausgefüllt.";
        }
        return null;
    };

    //@ts-ignore
    let blocker = useBlocker(shouldBlockNavigation);
    const location = useLocation();
    const navigate = useNavigate();

    const blockedProceed = () => {
        if (location.pathname === blocker.location?.pathname) {
            navigate(0);
        } else {
            //@ts-ignore
            blocker.proceed();
        }
    }

    return (
        <form onSubmit={props.handleSubmit} className={(props.className ? props.className : '') + (props.isLoading ? ' loading' : '')} id={props.id}>
            { props.displayRequiredHint ? <span>Die mit Sternchen gekennzeichneten Felder sind Pflichtfelder.</span> : '' }
            { props.intro ? <span>{props.intro}</span> : '' }
            { props.children }
            { props.isLoading && (
                <div className="loader"></div>
            )}
            { props.responseMessage && (
                <div className={`message${props.responseMessageClass ? ' ' + props.responseMessageClass : ''}`} role="alert">
                    <span>
                        {props.responseMessage}
                    </span>
                </div>
            ) }
            { props.generalErrors && (
                <div className='api-error'>
                    <span>{ props.generalErrors }</span>
                </div>
            ) }
            { !props.customSubmit && (
                <Button
                    buttonType='primary'
                    type='submit'
                    icon='check'
                    disabled={props.disabled}
                >Änderungen speichern</Button>
            ) }
            { navigateConfirmModal && 
                <NavigateConfirmModal 
                    proceed={() => blockedProceed()} 
                    setterCallback={setNavigateConfirmModal} 
                    text={<p className="align-center">Sind Sie sicher, dass Sie die Seite verlassen wollen? <br></br>Alle nicht gespeicherte Änderungen werden verloren gehen.</p>} 
                    leaveText={'ohne Speichern fortfahren'}
                />
            }
            { navigateConfirmModal2 && 
                <NavigateConfirmModal 
                    proceed={() => blockedProceed()} 
                    setterCallback={setNavigateConfirmModal2} 
                    text={<p className="align-center">Sind Sie sicher, dass Sie die Seite verlassen wollen? <br></br>Sie haben noch nicht alle Daten korrekt ausgefüllt.</p>}
                    leaveText={'Ja, verlassen'}
                />
            }
        </form>
    )
}

export default Form;
